<template>
    <div>
        <b-card>
            <span style="font-size: 2rem; font-weight: 500;">{{client_step_data.step_name}}</span>
            <form-plugin
            :admin="true"
            :viewFile="clientMediaFile(step_uid)"
            :step="client_step_data.render_order"
            @hasLoaded="has_form_loaded = true"
            @downloadFile=processFileDownload
            @formDataUpdated="updateFormData"
            :viewData="step_form_data"
            :uid="step_uid"></form-plugin>
            <!-- @uploaderData="processUpload"
            -->
        </b-card>
        <DownloadModal v-if="showDownloadModal" />
    </div>
</template>

<script>
import DownloadModal from '../../../client/downloadModal.vue'
//import Uploader from 'simple-uploader.js'
//eslint-disable-next-line
import _ from 'lodash'
import { licenseAppMethods, ccbAdminState, ccbAdminMethods } from '@/state/helpers'

export default {
    components:{
        DownloadModal,
    },
    data:() => ({
        showDownloadModal: false,
        has_form_loaded: false,
        current_form_data: {},
        params:{},
        hasSaved: false,
    }),
    computed:{
        ...ccbAdminState,
        step_form_data(){
            return this.client_step_data.spreadify_views[0].form_data
        },
        step_uid(){
            return this.client_step_data.spreadify_views[0].spreadify_uid
        },
    },
    methods:{
        ...licenseAppMethods,
        ...ccbAdminMethods,
        updateFormData(newData){
            //*event fired from <form-plugin>
            this.current_form_data = newData.data;
        },
        processFileDownload(params){
            this.showDownloadModal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('downloadModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'downloadModal'){
                        this.showDownloadModal = false;
                    }
                })
                this.getDownloadLink(params)
                .then(response => {
                    this.$eventHub.$emit('setDownloadUrl', response);
                })
            })
        },
        clientMediaFile(uid){
            let files = [];
            this.client_step_data.client_uploads.forEach((file) => {
                if(file.spreadify_uid == uid){
                    files.push(file);
                }
            });
            return files;
        },
    },
    mounted(){
        this.params = {
            step_id: this.client_step_data.id,
            form_data:[],
        }
    },
    beforeDestroy(){
        //*Fetch new data for the status bar and project timeline table
        /* No need, admin view
        if(this.hasSaved){
            this.loadAppData();
        }*/
    }
}
</script>

<style>

</style>